import { withRouter } from 'react-router-dom';
import MBHelmet from '../../components/MBHelmet';

export default withRouter(MBHelmet);
